/** Builds a lookup map (eventCode -> org event setting) from calendar event settings. */
export const buildOrgEventSettingsMap = (calendarEventSettings) =>
  (calendarEventSettings || []).reduce((acc, setting) => {
    acc[setting.eventCode] = setting
    return acc
  }, {})

/** Merges event types with server absences + org event settings into a unified mappings list for the UI. */
export const mergeMappingsFrom = ({
  filteredMappings,
  eventTypesOptions,
  integrationMode
}) =>
  (filteredMappings || []).map((mapping) => {
    const eventTypeOption = (eventTypesOptions || []).find((option) => option.value === mapping.absenceType)
    
    const inferredMemo = mapping.absenceType?.endsWith('P')
      ? 'Paid'
      : mapping.absenceType?.endsWith('U')
        ? 'Unpaid'
        : 'Other'
    const resolvedMemo = eventTypeOption?.paidness ?? mapping.memo ?? inferredMemo

    return {
      id: mapping?.id,
      absenceType: mapping.absenceType,
      payStatus: resolvedMemo,
      salaryTypeCode: mapping?.salaryTypeCode || '',
      payrollSystemType:
        mapping?.payrollSystemType ??
        (integrationMode === 'PROCOUNTOR'
          ? 'PROCOUNTOR'
          : integrationMode === 'ESALARY'
            ? 'ESALARY'
            : 'NOINTEGRATION'),
      formOfSalary: mapping?.formOfSalary ?? null,
      paymentGroup: mapping?.paymentGroup ?? '',
      status: mapping?.active,
      isNew: !mapping?.id
    }
  })

/**
 * Builds the row list for NOINTEGRATION mode.
 * Uses eventTypesOptions (full codelist) as the base so all event types are shown
 * even if no backend mapping exists yet. Enriches with any pre-existing mappings.
 */
export const mergeNoIntegrationMappingsFrom = ({
  eventTypesOptions,
  mappingsLookup,
  orgEventSettingsMap
}) =>
  (eventTypesOptions || []).map((option) => {
    const existing = mappingsLookup[option.value]
    const orgSetting = orgEventSettingsMap[option.value]

    return {
      id: existing?.id ?? null,
      absenceType: option.value,
      payStatus: option.paidness,
      salaryTypeCode: existing?.salaryTypeCode || '',
      payrollSystemType: 'NOINTEGRATION',
      formOfSalary: existing?.formOfSalary ?? null,
      paymentGroup: existing?.paymentGroup ?? '',
      status: orgSetting?.useStatus ?? true,
      isNew: !existing?.id
    }
  })